import { fetchMetricsBySiteId } from "../api/metricsApi";
import { parseMetrics } from "./metricsParsers";

export async function getSiteMetrics(siteId, timeout) {
    const now = new Date();
    const oneHourAgo = new Date(now.getTime() - 60 * 60 * 1000).toISOString();
    const end = now.toISOString();

    const raw = await fetchMetricsBySiteId({
        queryKey: ["metrics", siteId, oneHourAgo, end, 0, 100, timeout],
    });

    if (!Array.isArray(raw)) {
        return {};
    }

    const { latestMetrics, twentyMinuteMetrics } = parseMetrics(raw, siteId);
    return { latestMetrics, twentyMinuteMetrics };
}